/* Normalize CMS-authored aspect ratio values (e.g. "19 / 28", "1.5") into a CSS
 * aspect-ratio string. Used as a sizing hint via CSS, so parent layout rules can
 * still decide whether the ratio or stretched row height wins. */
export const parseAspectRatioCss = (value) => {
    if (value === null || value === undefined || value === '') return null
    if (typeof value === 'number' && Number.isFinite(value) && value > 0) return `${value}`
    if (typeof value !== 'string') return null

    const trimmed = value.trim()
    if (!trimmed) return null

    if (trimmed.includes('/')) {
        const [w, h] = trimmed.split('/').map((n) => Number(String(n).trim()))
        if (Number.isFinite(w) && Number.isFinite(h) && w > 0 && h > 0) {
            return `${w} / ${h}`
        }
        return null
    }

    const numeric = Number(trimmed)
    return Number.isFinite(numeric) && numeric > 0 ? `${numeric}` : null
}

export const mapAspectRatio = (raw) => {
    if (raw && typeof raw === 'object') {
        const entries = Object.entries(raw)
            .map(([bp, value]) => [bp, parseAspectRatioCss(value)])
            .filter(([, value]) => value)
        return entries.length ? Object.fromEntries(entries) : null
    }

    return parseAspectRatioCss(raw)
}
